import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import supabase from '../../lib/supabaseClient';

/**
 * ProtectedMoverRoute Component
 * Protects mover routes from unauthorized access
 */
const ProtectedMoverRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if user is logged in with Supabase
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session?.user) {
          setIsAuthenticated(false);
          setLoading(false);
          return;
        }

        // Check if this user is a mover by looking in movers_data table
        const { data: moverData, error } = await supabase
          .from('movers_data')
          .select('email')
          .eq('email', session.user.email)
          .single();

        if (error || !moverData) {
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin-mover" replace />;
  }

  return children;
};

export default ProtectedMoverRoute;
